<template>
  <div class="our-team-wrapper">
    <div class="our-team-title">
      <img :src="source('our-team')" alt="our team">
    </div>

    <div class="team-list-wrapper" ref="teamListRef" @mousedown="onmousedown" @mousemove="mousemove" @mouseup="mouseup">
      <div class="item" v-for="(item, index) in teamList" :key="index" @click="toPage('/team')">
        <img class="team-container" :src="item.src" alt="">
        <div class="team-mask">
          <img :src="source('team-mask')" alt="">
          <div class="name">{{ item.title }}</div>
        </div>
      </div>
    </div>

    <div class="team-view-more-wrapper" @click="toPage('/team')">
      <div class="img">
        VIEW MORE
        <img class="arrow" src="https://ucute.oss-cn-chengdu.aliyuncs.com/ucute_america_official_web/H5_home/brief-view-more-right-f_20230614074544135.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import key from "@/api/key";

export default {
  name: 'our-team',
  data() {
    return {
      teamList: [
        { src: this.source('team1'), title: 'PLANNING DEPARTMENT' },
        { src: this.source('team2'), title: 'DEPARTMENT OF DESIGN' },
        { src: this.source('team3'), title: 'VISUAL DEPARTMENT' },
        { src: this.source('team4'), title: 'TECHNOLOGY DEPARTMENT' },
        { src: this.source('team5'), title: 'BRAND SECTION' },
      ],
      // 鼠标是否在长按点击
      flag: false,
      // 鼠标点击下的位置信息
      downX: 0,
      // 首次点击滚顶条位置信息
      scrollLeft: 0,
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME_TEAM, name).fileUrl
    },
    onmousedown(event) {
      this.flag = true
      // 获取首次位置信息
      this.downX = event.clientX;
      this.scrollLeft = this.$refs.teamListRef.scrollLeft
    },
    mouseup(e) {
      this.flag = false
    },
    mousemove(event) {
      if (this.flag) {
        const scrollX = event.clientX - this.downX
        this.$refs.teamListRef.scrollLeft = this.scrollLeft - scrollX
      }
    },
    obsAnimation(el, fun, isUnobserve = false) {
      const ob = new IntersectionObserver(e => {
        if (!e[0].isIntersecting) return
        fun(el)
        if (isUnobserve) ob.unobserve(el)
      })
      ob.observe(el)
    },
    listAnimation() {
      this.obsAnimation(this.$refs.teamListRef, (el) => {
        for (let i = 0; i < el.children.length; i++) {
          el.children[i].style.transform = 'translateY(0)'
          el.children[i].style.transitionDelay = `${i * 200}ms`

        }
      }, false)
    }
  },
  mounted() {
    this.listAnimation()
  }
}
</script>

<style scoped lang="scss">
.our-team-wrapper {
  background-color: #191919;

  .our-team-title {
    display: flex;
    justify-content: center;

    img {
      width: 26.927vw;
      height: 5.573vw;
    }

  }

  .team-list-wrapper {
    margin-top: 4.479vw;
    padding: 0 7.5vw;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
    scrollbar-width: none;
    overflow-scrolling: touch;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    &:hover {
      cursor: grabbing;
      user-select: none;
    }


    .item {
      position: relative;
      display: inline-block;
      vertical-align: top;
      margin-right: 0.833vw;
      width: 17.5vw;
      height: 27.5vw;
      border-radius: 1.25vw;
      opacity: 1;
      transition: all 1s linear;
      transform: translateY(40vw);

      .team-container {
        width: 100%;
        height: 100%;
      }

      .team-mask {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 17.5vw;
        height: 27.5vw;
        border-radius: 1.25vw;
        cursor: pointer;
        transition: all .3s ease-in-out;

        &:hover {
          opacity: 1;
        }

        .name {
          width: 13vw;
          position: absolute;
          bottom: 1.354vw;
          left: 1.354vw;
          font-size: 1.667vw;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 1.667vw;
          white-space: normal;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }

      &:nth-child(1) {
        margin-top: 4.01vw;
      }

      &:nth-child(2) {
        margin-top: 11.979vw;
      }

      &:nth-child(3) {
        margin-top: 8.281vw;
      }

      &:nth-child(4) {
        margin-top: 0;
      }

      &:nth-child(5) {
        margin-top: 6.042vw;
      }
    }
  }

  .team-view-more-wrapper {
    display: flex;
    justify-content: flex-end;
    margin: 5.052vw 4.635vw 0 0;
    padding-bottom: 9.84375vw;

    &:hover {
      cursor: pointer;
    }

    .img {
      width: 18.49vw;
      height: 4.01vw;
      background-color: #0000ff;
      font-size: 2vw;
      font-weight: bold;
      color: #FFFFFF;
      border-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .arrow {
      width: 2.4vw;
      display: block;
      margin-left: 1vw;
      margin-bottom: .2vw;
      animation: rotate .8s linear infinite;
    }
  }
  @keyframes rotate {
    0%, 100% {
      transform: translateX(-0.5vw);
    }
    50% {
      transform: translateX(0.5vw);
    }
  }
}
</style>
